import * as React from "react";
import { Menu } from "antd";
import { FormattedMessage } from "react-intl";
import {getCurrentLan, Link} from "@netless/i18n-react-router";
import { withRouter } from "react-router";
import { RouteComponentProps } from "react-router";
import {
    AppstoreOutlined,
    BarChartOutlined, CodeOutlined,
    DashboardOutlined,
    DollarCircleOutlined,
    MonitorOutlined, UserOutlined,
} from "@ant-design/icons/lib";
const { SubMenu } = Menu;

export enum MenuSliderEnum {
    management = "management",
    finance = "finance",
    user_center = "user-center",
    debug = "debug",
    whiteboard = "whiteboard",
    static_conversion = "static-conversion",
    dynamic_conversion = "dynamic-conversion",
    dashboard = "dashboard",
    report = "report",
    log = "log",
    debug_room = "debug_room",
    debug_replay = "debug_replay",
    pay = "pay",
    bill = "bill",
    invoice = "invoice",
    info = "info",
    token = "token",
    password = "password",
    driver = "driver",
    search = "search",
    projects = "projects",
}

export type MenuSliderStates = {
    defaultOpenKey: string,
};

export type ActiveSelectedKeyType = {
    subKey: string,
    menuSlider: MenuSliderEnum,
};


class MenuSlider extends React.Component<RouteComponentProps<{}>, MenuSliderStates> {

    public constructor(props: RouteComponentProps<{}>) {
        super(props);
        this.state = {
            defaultOpenKey: "",
        };
    }

    private getActiveSelectedKey = (): ActiveSelectedKeyType => {
        let str = location.pathname;
        let str2 = location.pathname;
        const regex = /([^\/]+)/gm;
        const regex2 = /([^\/]+)/gm;
        regex.exec(str);
        regex2.exec(str2);
        regex2.exec(str2);
        const arr2 = regex.exec(str);
        const arr3 = regex2.exec(str2);
        if (arr2 === null) {
            str = "";
        } else {
            str = arr2[0];
        }
        if (arr3 === null) {
            str2 = "";
        } else {
            str2 = arr3[0];
        }
        switch (str) {
            case "projects": {
                return {
                    subKey: "",
                    menuSlider: MenuSliderEnum.projects,
                };
            }
            case "management": {
                return {
                    subKey: "",
                    menuSlider: MenuSliderEnum.management,
                };
            }
            case "finance": {
                if (str2 === "pay") {
                    return {
                        subKey: "finance",
                        menuSlider: MenuSliderEnum.pay,
                    };
                } else if (str2 === "bill") {
                    return {
                        subKey: "finance",
                        menuSlider: MenuSliderEnum.bill,
                    };
                } else {
                    return {
                        subKey: "finance",
                        menuSlider: MenuSliderEnum.invoice,
                    };
                }
            }
            case "user-center": {
                if (str2 === "info") {
                    return {
                        subKey: "user",
                        menuSlider: MenuSliderEnum.info,
                    };
                } else if (str2 === "token") {
                    return {
                        subKey: "user",
                        menuSlider: MenuSliderEnum.token,
                    };
                } else {
                    return {
                        subKey: "user",
                        menuSlider: MenuSliderEnum.driver,
                    };
                }
            }
            case "debug-center": {
                if (str2 === "room") {
                    return {
                        subKey: "debug",
                        menuSlider: MenuSliderEnum.debug_room,
                    };
                } else {
                    return {
                        subKey: "debug",
                        menuSlider: MenuSliderEnum.debug_replay,
                    };
                }
            }
            case "log": {
                return {
                    subKey: "",
                    menuSlider: MenuSliderEnum.log,
                };
            }
            case "data": {
                if (str2 === "static-conversion") {
                    return {
                        subKey: "data",
                        menuSlider: MenuSliderEnum.static_conversion,
                    };
                } else if (str2 === "dynamic-conversion") {
                    return {
                        subKey: "data",
                        menuSlider: MenuSliderEnum.dynamic_conversion,
                    };
                } else if (str2 === "report") {
                    return {
                        subKey: "data",
                        menuSlider: MenuSliderEnum.report,
                    };
                } else if (str2 === "search") {
                    return {
                        subKey: "data",
                        menuSlider: MenuSliderEnum.search,
                    };
                } else {
                    return {
                        subKey: "data",
                        menuSlider: MenuSliderEnum.whiteboard,
                    };
                }
            }
            default: {
                return {
                    subKey: "",
                    menuSlider: MenuSliderEnum.dashboard,
                };
            }
        }
    }
    public render(): React.ReactNode {
        const active_selected_key: ActiveSelectedKeyType = this.getActiveSelectedKey();
        const isEnglish: boolean = getCurrentLan() === "en";
        return (
            <Menu
                className="menu-box"
                theme="light"
                mode="inline"
                defaultOpenKeys={active_selected_key.subKey ? [active_selected_key.subKey] : undefined}
                selectedKeys={[active_selected_key.menuSlider]}
                defaultSelectedKeys={["1"]}>
                <Menu.Item key={MenuSliderEnum.dashboard}>
                    <Link to={"/"}>
                        <DashboardOutlined />
                        <span>
                            <FormattedMessage
                                id="global.console"
                            />
                        </span>
                    </Link>
                </Menu.Item >
                <Menu.Item key={MenuSliderEnum.log}>
                    <Link to={"/log/"}>
                        <MonitorOutlined />
                        <span>
                        <FormattedMessage
                                id="menu-slider.log-search"
                            />
                        </span>
                    </Link>
                </Menu.Item>
                {/* <Menu.Item key={MenuSliderEnum.projects}>
                    <Link to={"/projects/"}>
                        <AppstoreOutlined />
                        <span>
                            <FormattedMessage
                                id="global.application-management"
                            />
                        </span>
                    </Link>
                </Menu.Item> */}
                <SubMenu
                    key="data"
                    title={
                        <span>
                            <BarChartOutlined />
                            <FormattedMessage
                                id="menu-slider.product-dosage"
                            />
                        </span>
                    }
                >
                    <Menu.Item key={MenuSliderEnum.report}>
                        <Link to={"/data/report/"}>
                            <FormattedMessage
                                id="menu-slider.report"
                            />
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={MenuSliderEnum.whiteboard}>
                        <Link to={"/data/whiteboard/"}>
                            <FormattedMessage
                                id="menu-slider.interactive-whiteboard"
                            />
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={MenuSliderEnum.static_conversion}>
                        <Link to={"/data/static-conversion/"}>
                            <FormattedMessage
                                id="menu-slider.document-to-picture"
                            />
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={MenuSliderEnum.dynamic_conversion}>
                        <Link to={"/data/dynamic-conversion/"}>
                            <FormattedMessage
                                id="menu-slider.document-to-web"
                            />
                        </Link>
                    </Menu.Item>
                </SubMenu>
                <SubMenu
                    key={"finance"}
                    title={
                        <span>
                            <DollarCircleOutlined />
                            <FormattedMessage
                                id="global.financial-statistics"
                            />
                        </span>
                    }
                >
                    {/* <Menu.Item key={MenuSliderEnum.pay}>
                        <Link to={"/finance/pay/"}>
                            <FormattedMessage
                                id="menu-slider.pay-recharge"
                            />
                        </Link>
                    </Menu.Item> */}
                    <Menu.Item key={MenuSliderEnum.bill}>
                        <Link to={"/finance/bill/"}>
                            <FormattedMessage
                                id="menu-slider.billing-list"
                            />
                        </Link>
                    </Menu.Item>
                    {/* {isEnglish ? null : <Menu.Item key={MenuSliderEnum.invoice}>
                        <Link to={"/finance/invoice/"}>
                            发票与地址
                        </Link>
                    </Menu.Item>} */}
                </SubMenu>
                <SubMenu
                    key="user"
                    title={
                        <span>
                            <UserOutlined />
                            <FormattedMessage
                                id="global.user-center"
                            />
                        </span>
                    }
                >
                    <Menu.Item key={MenuSliderEnum.info}>
                        <Link to={"/user-center/info/"}>
                            <FormattedMessage
                                id="menu-slider.basic-information"
                            />
                        </Link>
                    </Menu.Item>
                    {/* <Menu.Item key={MenuSliderEnum.driver}>
                        <Link to={"/user-center/driver/"}>
                            <FormattedMessage
                                id="menu-slider.storage-config"
                            />
                        </Link>
                    </Menu.Item> */}
                </SubMenu>
                <SubMenu
                    key="debug"
                    title={
                        <span>
                            <CodeOutlined />
                            <FormattedMessage
                                id="global.debug-center"
                            />
                        </span>
                    }
                >
                    <Menu.Item key={MenuSliderEnum.debug_room}>
                        <Link to={"/debug-center/room/"}>
                            <FormattedMessage
                                id="debug.realtime-room"
                            />
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={MenuSliderEnum.debug_replay}>
                        <Link to={"/debug-center/replay/"}>
                            <FormattedMessage
                                id="debug.replay-room"
                            />
                        </Link>
                    </Menu.Item>
                </SubMenu>
            </Menu>
        );
    }
}

export default withRouter(MenuSlider);



// WEBPACK FOOTER //
// ./src/components/portal/MenuSlider.tsx